import { render, staticRenderFns } from "./index.vue?vue&type=template&id=125c2a16&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=125c2a16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125c2a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125c2a16')) {
      api.createRecord('125c2a16', component.options)
    } else {
      api.reload('125c2a16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=125c2a16&scoped=true", function () {
      api.rerender('125c2a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantClass/add-commontime/index.vue"
export default component.exports